import styled from "styled-components";

export const Wrapper = styled.div`
  text-align: center;
  padding: 1rem;
  margin: 2rem 2rem 1rem 2rem;
`;

export const Name = styled.p`
  font-size: 1rem;
  font-weight: 500;
`;

export const Location = styled.p`
  font-size: 0.875rem;
`;

export const Date = styled.p`
  font-size: 0.75rem;
`;
